package com.mrpowergamerbr.puppydough.webtale

import web.file.File

sealed class UIState {
    data class Ready(val version: WebtaleConfig.GameVersion) : UIState()
    data object UploadGame : UIState()
    data class DetectedGame(val gameWADFile: File, val files: List<File>, val hash: String, val gameWAD: GameWADRef?) : UIState()
    data class ProcessingGame(val filename: String, val count: Int, val total: Int) : UIState()
    data object SelectGameVersion : UIState()
}